var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxClosed = function SvgBoxClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.625 8.125h-3.687v3.125h5.484l-1.227-2.754a.63.63 0 0 0-.57-.371m2.25 5H8.125v8.125c0 .344.281.625.625.625h12.5a.627.627 0 0 0 .625-.625zM8.578 11.25h5.485V8.125h-3.688a.62.62 0 0 0-.57.371zm11.047-5c.988 0 1.883.582 2.285 1.484l1.625 3.657c.14.32.215.664.215 1.015v8.844c0 1.379-1.121 2.5-2.5 2.5H8.75a2.5 2.5 0 0 1-2.5-2.5v-8.844c0-.351.074-.695.215-1.015L8.09 7.734a2.5 2.5 0 0 1 2.285-1.484z"
  })));
};
export default SvgBoxClosed;